import { usePromotionsStore, useUserStore, useRestaurantStore } from '~/store'
import type { Promotion } from '~/types/api/data-contracts'

export function useProminentPromotions() {
  const promotionsStore = usePromotionsStore()
  const userStore = useUserStore()
  const restaurantStore = useRestaurantStore()

  const activePromotion = ref<Promotion | null>(null)
  const isModalOpen = ref(false)

  function performProminentPromotionCheck(currentPath: string | undefined) {
    const { isMobileMode } = useAppMode()
    if (!restaurantStore.shouldShowProminentPromotion) {
      return
    }

    if (restaurantStore.getWillShowOrderConfigConfirmation) {
      return
    }

    if (isMobileMode && !userStore.hasOnboarded) {
      return
    }

    if (currentPath === '/checkout') {
      return
    }

    if (currentPath && !currentPath.startsWith('/home')) {
      // Do not show promotions on any page other than home
      return
    }

    const prominentPromotion = promotionsStore.promotions.find((x) => x.detailIsProminent === true)
    if (
      prominentPromotion !== undefined &&
      prominentPromotion.detailProminentId !== promotionsStore.lastPresentedProminentPromotionId
    ) {
      openPromoModal(prominentPromotion)
    }
  }

  function openPromoModal(promotion: Promotion) {
    activePromotion.value = promotion
    isModalOpen.value = true
    promotionsStore.lastPresentedProminentPromotionId = promotion.detailProminentId
  }

  return {
    activePromotion: readonly(activePromotion),
    isModalOpen,
    performProminentPromotionCheck
  }
}
